$(function(){

    $(document).on('open-auth', function(e, options){
        e.preventDefault();

        options = options || {};

        $$.openModal('auth-signin', {
            afterOpen: function(modal, $modal){
                var $loginInput = $modal.find('[name="login"]');

                $modal.find('form').formHandle({
                    overlay: true,
                    success: function(response){
                        if(options.authSuccess){
                            switch(options.authSuccess){
                                case 'ecommerce-cart-order':
                                    $modal.arcticmodal('close');
                                    $('[js-ecommerce-cart-order]').trigger('click');
                                    break;

                            }
                        } else if (response.open_modal) {
                            let $modalContent = $(response.open_modal);
                            $$.openModal($modalContent, {
                                afterOpen: function (modal, $modal) {
                                    $.ajax({
                                        url: '/office/email_update_show',
                                        type: 'post',
                                    });

                                    $modal.find('form').formHandle({
                                        overlay: true,
                                        success: function (data, $form) {
                                            if (data.message) {
                                                $form.closest('div').slideUp(function () {
                                                    $form.closest('div').html('<div class="form__success">' + data.message + '</div>').slideDown();
                                                });
                                            }
                                            if (data.redirect) {
                                                if (data.message) {
                                                    setTimeout(function () {
                                                        document.location.href = data.redirect;
                                                    }, 4000);
                                                } else {
                                                    document.location.href = data.redirect;
                                                }
                                            }
                                            setTimeout(function () {
                                                $.arcticmodal('close');
                                            }, 4000)
                                        }
                                    });
                                },
                                afterClose: function () {
                                    if (response.redirect) {
                                        document.location.href = response.redirect;
                                    }
                                }
                            });
                            
                        }else if(response.redirect){
                            document.location.href = response.redirect;
                        }
                    }
                });

                $modal.find('[js-auth-remind]').on('click', function(e){
                    e.preventDefault();
                    $$.openModal('auth-remind', {
                        afterOpen: function(modal, $modal){
                            $modal.find('[name="login"]').val($loginInput.val()).trigger('changeSilent');
                            $modal.find('form').formHandle({
                                overlay: true,
                                success: function(response, $form){
                                    $form.slideUp(300, function(){
                                        var $message = $('<div class="form-message"/>').text(response.message)
                                            .append(
                                                $('<div class="form__actions"><button class="button" type="submit"><span>Закрыть</span></button></div>')
                                                    .on('click', function(e){
                                                        e.preventDefault();
                                                        $modal.arcticmodal('close');
                                                    })
                                            );

                                        $form.after($message);
                                        $message.hide().slideDown(300);
                                    });
                                }
                            });
                        }
                    });
                });
            }
        });
    }).on('click','[js-auth-signin]', function (e) {
        e.preventDefault();
        $(document).triggerHandler('open-auth', e.currentTarget.dataset);
    });

    $('[js-auth-signin][js-modal-auto]').each(function () {
        $(document).triggerHandler('open-auth', this.dataset);
    });
});